import React from 'react'
import { EntityWorkflowResults } from './EntityWorkflowResults'

export interface MeetingWorkflowResultsProps {
  roomId: string
  sessionId: string
  accountId: string
}

export const MeetingWorkflowResults: React.FC<MeetingWorkflowResultsProps> = ({ roomId, sessionId, accountId }) => (
  <EntityWorkflowResults entityType='meeting' entityId={`${roomId}:${sessionId}`} accountId={accountId} />
)
